import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Bredcrumb from '../../HomeMain/Bredcrumb'
import RelatedServices from '../RelatedServices'
import { cld } from '../../../utils/cld'
import MakeupGallery from './MakeupGallery'

const Img29 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1757965882/29_ywnv9q.jpg"
const Img31 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1757965883/31_s8k9yd.jpg"
const Img32 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758314692/32_gildou.jpg"

const SVILENE_TREPAVICE_IMAGES = [
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973032/IMG_4626_l0u5kr.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973032/IMG_4627_fjz54q.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973033/IMG_4625_rqyzoe.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973033/IMG_4613_bfwtds.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973033/CEE2AFC2-BDCA-4489-A98F-D923285A5BD3_k34kai.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973034/IMG_4616_puq433.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973034/Pink_and_Beige_Minimalist_Lashes_Salon_Instagram_Post_cqikw0.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973034/IMG_4615_pwylon.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973034/SVILENE_TREPAVICE_radqpz.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973036/SVILENE_TREPAVICE_1_tsha3v.png",
]

const LIFTING_IMAGES = [
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973329/3C302DCE-4BCB-4959-AA98-880BBB70A4DF_yrwzvx.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973329/IMG_0372_wqctnl.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973329/IMG_2956_aocgwz.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973330/IMG_6231_ahlphh.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973329/IMG_6228_tswcri.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973329/IMG_5430_pc4ztm.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973331/IMG_7833_wffrfu.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779973331/IMG_8239_ziovcr.jpg",
]

const callBtnStyle = {
  display: "inline-block",
  padding: "15px 35px",
  backgroundColor: "#90510F",
  color: "#ffffffff",
  fontWeight: "600",
  fontSize: "1.2rem",
  borderRadius: "8px",
  textDecoration: "none",
  border: "1px solid #ddd",
  transition: "transform 0.3s",
}

const Main = () => {
  const { t } = useTranslation()

  const sidebarLinks = [
    { to: "/makeup",           label: t('servicesSidebar.makeup'),          active: false },
    { to: "/permanent-makeup", label: t('servicesSidebar.permanentMakeup'), active: false },
    { to: "/vega",             label: t('servicesSidebar.vega'),            active: false },
    { to: "/baby-lips",        label: t('servicesSidebar.babyLips'),        active: false },
    { to: "/eyelashes",        label: t('servicesSidebar.eyelashes'),       active: true  },
    { to: "/nails",            label: t('servicesSidebar.nails'),           active: false },
    { to: "/depilation",       label: t('servicesSidebar.depilation'),      active: false },
    { to: "/hairdresser",      label: t('servicesSidebar.hairdresser'),     active: false },
  ]

  const ContactBox = () => (
    <div className="service-detail-contact wow fadeup-animation" data-wow-delay="1.1s">
      <h3 className="h3-title">{t('servicesSidebar.contactTitle')}</h3>
      <a
        href="tel:0653585545"
        style={callBtnStyle}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        {t('servicesSidebar.callNow')}
      </a>
    </div>
  )

  return (
    <>
      <Bredcrumb title={t('eyelashesService.breadcrumbTitle')} subtitle={t('eyelashesService.breadcrumbSubtitle')} />

      <div className="about-area5 about-p p-relative">
        <div className="container pt-120 pb-90">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-4 order-1">
              <aside className="sidebar services-sidebar">
                <div className="sidebar-widget categories">
                  <div className="widget-content">
                    <ul className="services-categories">
                      {sidebarLinks.map(({ to, label, active }) => (
                        <li key={to} className={active ? 'active' : ''}>
                          <Link to={to}>{label} <i className="fa fa-arrow-right"></i></Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="d-none d-lg-block">
                  <ContactBox />
                </div>
              </aside>
            </div>
            <div className="col-lg-8 col-md-12 col-sm-12 order-2">
              <div className="service-detail">
                <div className="content-box">
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 32px', justifyContent: 'center', alignItems: 'flex-start', marginBottom: '32px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h2 style={{ marginBottom: '8px' }}>{t('eyelashesService.silkTitle')}</h2>
                      <MakeupGallery images={SVILENE_TREPAVICE_IMAGES} ariaLabel="silk eyelashes" altPrefix="Silk Eyelashes" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h2 style={{ marginBottom: '8px' }}>{t('eyelashesService.liftingTitle')}</h2>
                      <MakeupGallery images={LIFTING_IMAGES} ariaLabel="lash lift" altPrefix="Lash Lift" />
                    </div>
                  </div>

                  <h2>{t('eyelashesService.h2')}</h2>
                  <p>{t('eyelashesService.p1')}</p>
                  <div className="two-column">
                    <div className="row">
                      <div className="image-column col-xl-6 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(Img29, { w: 1100 })} alt="Eyelashes" width="1100" height="733" loading="lazy" decoding="async" /></figure>
                      </div>
                      <div className="text-column col-xl-6 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(Img31, { w: 1100 })} alt="Eyelashes" width="1100" height="733" loading="lazy" decoding="async" /></figure>
                      </div>
                    </div>
                  </div>

                  <h3>{t('eyelashesService.comparisonTitle')}</h3>
                  <h3>{t('eyelashesService.summaryTitle')}</h3>
                  <p><strong>{t('eyelashesService.liftingShortTitle')}</strong></p>
                  <p>{t('eyelashesService.liftingShortText')}</p>
                  <p><strong>{t('eyelashesService.silkShortTitle')}</strong></p>
                  <p>{t('eyelashesService.silkShortText')}</p>
                  <p>{t('eyelashesService.readMore')}</p>

                  <h3>{t('eyelashesService.silkH3')}</h3>
                  <p>{t('eyelashesService.silkP1')}</p>
                  <p>{t('eyelashesService.silkP2')}</p>
                  <p>{t('eyelashesService.silkP3')}</p>

                  <h3>{t('eyelashesService.type1Title')}</h3>
                  <p>{t('eyelashesService.type1P1')}</p>
                  <p>{t('eyelashesService.type1P2')}</p>
                  <p>{t('eyelashesService.type1P3')}</p>

                  <h3>{t('eyelashesService.type2Title')}</h3>
                  <p>{t('eyelashesService.type2P1')}</p>
                  <p>{t('eyelashesService.type2P2')}</p>
                  <p>{t('eyelashesService.type2P3')}</p>

                  <h3>{t('eyelashesService.type3Title')}</h3>
                  <p>{t('eyelashesService.type3P1')}</p>
                  <p>{t('eyelashesService.type3P2')}</p>
                  <p>{t('eyelashesService.type3P3')}</p>

                  <h3>{t('eyelashesService.type4Title')}</h3>
                  <p>{t('eyelashesService.type4P1')}</p>
                  <p>{t('eyelashesService.type4P2')}</p>
                  <p>{t('eyelashesService.type4P3')}</p>

                  <h3>{t('eyelashesService.type5Title')}</h3>
                  <p>{t('eyelashesService.type5P1')}</p>
                  <p>{t('eyelashesService.type5P2')}</p>
                  <p>{t('eyelashesService.type5P3')}</p>

                  <h3>{t('eyelashesService.processTitle')}</h3>
                  <ul>
                    {t('eyelashesService.processItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>{i + 1}. {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('eyelashesService.silkMaintenanceTitle')}</h3>
                  <ul>
                    {t('eyelashesService.silkMaintenanceItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('eyelashesService.silkBenefitsTitle')}</h3>
                  <ul>
                    {t('eyelashesService.silkBenefitsItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('eyelashesService.silkConclusion')}</h3>

                  <h3>{t('eyelashesService.liftingH3')}</h3>
                  <p>{t('eyelashesService.liftingP1')}</p>

                  <h3>{t('eyelashesService.liftingWhyTitle')}</h3>
                  <ul>
                    {t('eyelashesService.liftingWhyItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('eyelashesService.liftingProcessTitle')}</h3>
                  <ul>
                    {t('eyelashesService.liftingProcessItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>{i + 1}. {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('eyelashesService.liftingMaintenanceTitle')}</h3>
                  <ul>
                    {t('eyelashesService.liftingMaintenanceItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('eyelashesService.liftingBenefitsTitle')}</h3>
                  <ul>
                    {t('eyelashesService.liftingBenefitsItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('eyelashesService.liftingConclusion')}</h3>
                  <br />

                  <div className="two-column">
                    <div className="row">
                      <div className="image-column col-xl-12 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(Img32, { w: 1100 })} alt="Eyelashes" width="1100" height="733" loading="lazy" decoding="async" /></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RelatedServices items={[{ to: "/nails", labelKey: "servicesSidebar.nails" }, { to: "/permanent-makeup", labelKey: "servicesSidebar.permanentMakeup" }]} />
          <div className="row d-lg-none">
            <div className="col-12">
              <ContactBox />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Main
